import { render, staticRenderFns } from "./UpsertSpeciality.vue?vue&type=template&id=d09ae4da&scoped=true"
import script from "./UpsertSpeciality.vue?vue&type=script&lang=ts"
export * from "./UpsertSpeciality.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09ae4da",
  null
  
)

export default component.exports